/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Marketplace, MarketplaceInterface } from "../Marketplace";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nativeTokenWrapper",
        type: "address",
      },
      {
        internalType: "address",
        name: "_thirdwebFee",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "timeBuffer",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidBufferBps",
        type: "uint256",
      },
    ],
    name: "AuctionBuffersUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "closer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "cancelled",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "auctionCreator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "winningBidder",
        type: "address",
      },
    ],
    name: "AuctionClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "lister",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "tokenOwner",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "reservePricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyoutPricePerToken",
            type: "uint256",
          },
          {
            internalType: "enum IMarketplace.TokenType",
            name: "tokenType",
            type: "uint8",
          },
          {
            internalType: "enum IMarketplace.ListingType",
            name: "listingType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct IMarketplace.Listing",
        name: "listing",
        type: "tuple",
      },
    ],
    name: "ListingAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "listingCreator",
        type: "address",
      },
    ],
    name: "ListingRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "listingCreator",
        type: "address",
      },
    ],
    name: "ListingUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "offeror",
        type: "address",
      },
      {
        indexed: true,
        internalType: "enum IMarketplace.ListingType",
        name: "listingType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantityWanted",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalOfferAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "currency",
        type: "address",
      },
    ],
    name: "NewOffer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "lister",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantityBought",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalPricePaid",
        type: "uint256",
      },
    ],
    name: "NewSale",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "platformFeeRecipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "platformFeeBps",
        type: "uint256",
      },
    ],
    name: "PlatformFeeInfoUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_BPS",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_offeror",
        type: "address",
      },
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_pricePerToken",
        type: "uint256",
      },
    ],
    name: "acceptOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bidBufferBps",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_buyFor",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_quantityToBuy",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_totalPrice",
        type: "uint256",
      },
    ],
    name: "buy",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
    ],
    name: "cancelDirectListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_closeFor",
        type: "address",
      },
    ],
    name: "closeAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "contractType",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractVersion",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "secondsUntilEndTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantityToList",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currencyToAccept",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "reservePricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyoutPricePerToken",
            type: "uint256",
          },
          {
            internalType: "enum IMarketplace.ListingType",
            name: "listingType",
            type: "uint8",
          },
        ],
        internalType: "struct IMarketplace.ListingParameters",
        name: "_params",
        type: "tuple",
      },
    ],
    name: "createListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getPlatformFeeInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_defaultAdmin",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractURI",
        type: "string",
      },
      {
        internalType: "address[]",
        name: "_trustedForwarders",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_platformFeeRecipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_platformFeeBps",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "listings",
    outputs: [
      {
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "reservePricePerToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buyoutPricePerToken",
        type: "uint256",
      },
      {
        internalType: "enum IMarketplace.TokenType",
        name: "tokenType",
        type: "uint8",
      },
      {
        internalType: "enum IMarketplace.ListingType",
        name: "listingType",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantityWanted",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_pricePerToken",
        type: "uint256",
      },
    ],
    name: "offer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "offers",
    outputs: [
      {
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "offeror",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quantityWanted",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pricePerToken",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_timeBuffer",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_bidBufferBps",
        type: "uint256",
      },
    ],
    name: "setAuctionBuffers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_platformFeeRecipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_platformFeeBps",
        type: "uint256",
      },
    ],
    name: "setPlatformFeeInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "thirdwebFee",
    outputs: [
      {
        internalType: "contract ITWFee",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeBuffer",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalListings",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantityToList",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_reservePricePerToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_buyoutPricePerToken",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_currencyToAccept",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_secondsUntilEndTime",
        type: "uint256",
      },
    ],
    name: "updateListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "winningBid",
    outputs: [
      {
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "offeror",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quantityWanted",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pricePerToken",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type MarketplaceConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MarketplaceConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Marketplace__factory extends ContractFactory {
  constructor(...args: MarketplaceConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Marketplace";
  }

  deploy(
    _nativeTokenWrapper: string,
    _thirdwebFee: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Marketplace> {
    return super.deploy(
      _nativeTokenWrapper,
      _thirdwebFee,
      overrides || {}
    ) as Promise<Marketplace>;
  }
  getDeployTransaction(
    _nativeTokenWrapper: string,
    _thirdwebFee: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _nativeTokenWrapper,
      _thirdwebFee,
      overrides || {}
    );
  }
  attach(address: string): Marketplace {
    return super.attach(address) as Marketplace;
  }
  connect(signer: Signer): Marketplace__factory {
    return super.connect(signer) as Marketplace__factory;
  }
  static readonly contractName: "Marketplace";
  public readonly contractName: "Marketplace";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MarketplaceInterface {
    return new utils.Interface(_abi) as MarketplaceInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Marketplace {
    return new Contract(address, _abi, signerOrProvider) as Marketplace;
  }
}
